import type React from 'react';

import type { HandlerId } from '@vlabs/api/artemy/model';
import { Modal } from '@vlabs/uikit';

import { CreatedHandlerForm } from './CreatedHandlerForm';

interface CreatedHandlerModalProps {
  handlerId?: HandlerId;
  handlerName?: string;
  onClose: VoidFunction;
}

function CreatedHandlerModal({
  handlerId = undefined,
  handlerName = undefined,
  onClose,
}: CreatedHandlerModalProps): React.JSX.Element {
  return (
    <Modal
      appElement={document.getElementById('root') ?? undefined}
      isOpen={handlerId !== undefined}
      onRequestClose={onClose}
      size="small"
    >
      <CreatedHandlerForm
        handlerId={handlerId}
        handlerName={handlerName}
      />
    </Modal>
  );
}

export { CreatedHandlerModal };
